export default {
  methods: {

    liveUpdate (update) {

      console.log('\n\n\n!!! Live update: ', {...update});
    
      var open = false;
       
      // Ticket Update
      if (update.model === 'ticket') {

        // Store whether or not this ticket is currently open
        open = (this.$route.name === 'tickets' && this.$route.query.details && this.$route.query.details === update.data._id);

        if (!update.preview) {

          // Assignees Removed - May not be able to fetch updated ticket
          if (update.action === 'update.assignees.remove') {
            this.removeTicketAssignee(update, open);
          }

          // All Other instances, should be able to fetch the Ticket
          else {

            var ticketId;
            if (update.action === 'update.image.add') {
              ticketId = update.data.ticket;
            }
            else {
              ticketId = update.data._id;
            }
            
            // Get the ticket from the server so we have all the data populated in the store
            this.$store.dispatch('loadTicket', {
              ticket: ticketId
            })
            .then(data => {
            
              // Status Updated
              if (update.action === 'update.status') {
                this.updateTicketStatus(update, open);
              }
              
              // Status Updated
              if (update.action === 'update.tags.add' || update.action === 'update.tags.remove') {
                this.updateTicketTags(update, open);
              }
              
              // Assignees Added
              if (update.action === 'update.assignees.add') {
                this.addTicketAssignee(update, open);
              }
              
              // Add Images
              if (update.action === 'update.image.add') {
                this.addTicketImages(update, open);
              }
              
              // Ticket Created
              if (update.action === 'create') {
                this.createTicket(update, open);
              }
              
            })
            .catch(e => {
              console.log(e);
              Toast.showError(e);
            });
          }
        }
      }

      // Ticket Note
      if (update.model === 'ticketNote') {

        // Store whether or not this ticket is currently open
        open = (this.$route.name === 'tickets' && this.$route.query.details && this.$route.query.details === update.data.ticket._id);

        if (!update.preview) this.createTicketNote(update, open);
      }

      // Ticket Comment
      if (update.model === 'ticketComment') {

        var check = _.isArray(update.data) ? update.data[0].ticket : update.data.ticket;
        if (_.isObject(check)) check = check._id;

        // Store whether or not this ticket is currently open
        open = (this.$route.name === 'tickets' && this.$route.query.details && 
        this.$route.query.details === check); 

        if (!update.preview) this.createTicketChat(update, open);
      }

      // Activity Tray
      if (update.preview && update.createdBy !== this.$store.getters.profile._id) {
        this.createNotification(update, open);
      }

    },

    updateTicketStatus (update, open) {
      
      // Show Toast if open
      if (open && update.createdBy !== this.$store.getters.profile._id) {
        Toast.show('Ticket status changed to ' + update.data.status + '.', 'notify');
      }
      
      // Update Ticket List
      this.updateTicketList(update.data._id);
      
      // Dispatch Event
      window.dispatch('ticketUpdated', update); 
    },

    updateTicketTags (update, open) {

      // Show Toast if open
      if (open && update.createdBy !== this.$store.getters.profile._id) {
        Toast.show('Ticket tags updated.', 'notify');
      }
    
      // Update Ticket List
      this.updateTicketList(update.data._id);
      
      // Dispatch Event
      window.dispatch('ticketUpdated', update); 
    },

    addTicketAssignee (update, open) {
      
      // Commit Users
      this.$store.commit('storeUsers', update.data.added);

      // Show Toast
      if (open && update.createdBy !== this.$store.getters.profile._id) {
        var addedString = '';
        for (var i = 0; i < update.data.added.length; ++i) {
          if (i < 0) addedString += ', ';
          addedString += update.data.added[i].fullName;
        }
        addedString += update.data.added.length > 1 ? ' were' : ' was';
        addedString += ' assigned to this ticket.'
        Toast.show(addedString, 'notify');
      }

      // Update Ticket List
      this.updateTicketList(update.data._id);

      // Dispatch ticketUpdated
      window.dispatch('ticketUpdated', update);
    },

    removeTicketAssignee (update, open) {
      var removed = false;

      // For some reason, the live update that comes back includes the removed user as an assignee. This logic will remove that user before we continue.
      var difference = [];
      
      update.data.assignees.forEach(assignee => {
      
        var found = false;
        update.data.removed.forEach(remove => {
          if (assignee._id === remove._id) {
            found = true;
          }
        });

        if (!found) {
          difference.push(assignee);
        }

      }); 
      update.data.assignees = difference;
      
      // Remove the Assignee
      removed = this.removeAssignee(update);

      // If the user wasn't removed, commit the Ticket
      if (!removed) {
        this.$store.dispatch('loadTicket', {
          ticket: update.data._id
        })
        .then(data => {

          // Show toast of the update
          if (open && update.createdBy !== this.$store.getters.profile._id) {
            var removedString = '';
            for (var i = 0; i < update.data.removed.length; ++i) {
              if (i < 0) removedString += ', ';
              removedString += update.data.removed[i].fullName;
            }
            removedString += update.data.removed.length > 1 ? ' were' : ' was';
            removedString += ' unassigned from this ticket.'
            Toast.show(removedString, 'notify');
          }
    
          // Update Ticket List
          this.updateTicketList(update.data._id);
    
          // Dispatch ticketUpdated
          window.dispatch('ticketUpdated', update);

        })
      } 
    },

    removeAssignee (update) {
        
      // Commit Users
      this.$store.commit('storeUsers', update.data.removed);

      // Check that this user is in the ticket still
      var found = false;
      update.data.assignees.forEach(assignee => {
        if (assignee._id === this.$store.getters.profile._id) {
          found = true;
        }
      })

      // Remove access to this ticket
      if (!found && !this.hasPermissionsInProperty(['ticketAdmin'], update.data.property)) {

        if (this.$route.name === 'tickets') {
          
          // Unselect if Selected
          if (this.app.pages.tickets.selected === update.data._id) this.app.pages.tickets.selected = false;

          // Reroute if this ticket is open
          if (this.$route.query.details && this.$route.query.details === update.data._id) {

            // Show Toast
            Toast.show('You have been removed from this ticket.', 'notify');
            
            this.routeRemoveQuery('details');
          }

          // Remove from store
        }

        this.$store.commit('removeTicket', update.data._id);
        this.app.pages.tickets.list.removeItem(update.data._id);

        // User was removed
        return true;
      }
      // User not removed
      return false;
    },


    addTicketImages (update) {
      
      // Update Ticket List
      this.updateTicketList(update.data._id);
      
      // Dispatch ticketUpdated
      window.dispatch('ticketUpdated', update);
    },

    createTicket (update) {

      // Update List
      this.updateTicketList(update.data._id);

      // Dispatch ticketCreated
      window.dispatch('ticketCreated', update);
    },

    updateTicketList (ticketId) {

      var ticket = this.$store.getters.ticket(ticketId);
      var list    = this.app.pages.tickets.list;
      var filters = this.app.pages.tickets.filtering.filters;
      var sort    = this.app.pages.tickets.sort;

      // Check Filters and Sorts see if we should add to the list
      // Check if it's already in the list to save us some time
      
      var testFilters = function () {
  
        var satisfiesFilter = true;

        // Check Properties
        if (filters.property.value !== 'all' && filters.property.value !== ticket.property) satisfiesFilter = false;
  
        // Unresolved filter, but not unresolved
        if (filters.status.value === 'unresolved' && ticket.status === 'resolved') satisfiesFilter = false;
  
        // Not unresolved filter, filters don't match
        if (filters.status.value !== 'unresolved' && filters.status.value !== ticket.status) satisfiesFilter = false; 
  
        // Check Ticket Tags
        if (filters.type.value !== 'all') {
          if (!(ticket.type.includes(filters.type.value))) satisfiesFilter = false;
        }

        return satisfiesFilter;
      }
      
      var satisfiesFilter = testFilters();
      
      // Ticket is already in the list but now shouldn't be
      if (!satisfiesFilter && this.app.pages.tickets.list.items.includes(ticket._id)) {
        this.app.pages.tickets.list.removeItem(ticket._id);        
      }
      // Ticket not in the list but should be
      else if (satisfiesFilter && (!this.app.pages.tickets.list.items.includes(ticket._id))) {
        
        var add = false; 
      
        var firstTicket = this.$store.getters.ticket(list.items[0]);
        var lastTicket = this.$store.getters.ticket(list.items[list.items.length - 1]);
        
        if (list.noMoreItems) add = true;
        else if (sort.options[sort.value].value > 0) {
          // Ascending (oldest to newest) so check if the last ticket in this list is newer than this ticket, if it is, add this ticket
          
          if (lastTicket[sort.value] > ticket[sort.value]) add = true;
        }
        else {
          // Descending (newest to oldest) so check if the oldest loaded ticket is older than the ticket, if it is, add this ticket
          
          if (lastTicket[sort.value] < ticket[sort.value]) add = true;
        }

        // Add it wherever, we will sort it below
        if (add) {
          this.app.pages.tickets.list.addItem(ticket._id);
        }
      }

      // Either way, sort the list
      var sortFunction = (a, b) => {

        // Use the sort value to determine how to sort the data
        var i = sort.options[sort.value].value;

        return this.$store.getters.ticket(a)[sort.value] > this.$store.getters.ticket(b)[sort.value] ? i : -i;
      } 

      this.app.pages.tickets.list.sortList(sortFunction);
    },

    createTicketNote (update, open) {

      // Can't load Ticket Note from server because no route for fetching a single Ticket Note, but we have enough data from the Live Update to simulate it anyway

      // For some reason, User is a field instead of createdBy, so we'll move that before adding it to the store
      update.data.createdBy = update.data.user;
      delete update.data.user;

      // Add to Store
      this.$store.dispatch('storeTicketNoteLiveUpdate', {...update.data});

      // Current Ticket Open
      if (open) {

        // Show Toast
        if (this.app.pages.tickets.ticketNotes.list.loaded && update.createdBy !== this.$store.getters.profile._id) {
          Toast.show(update.data.createdBy.firstName + ' ' + update.data.createdBy.lastName + ' added a note.', 'notify');
        }

        // Add to List
        this.app.pages.tickets.ticketNotes.list.addItem(update.data._id, { 
          unshift: true 
        });
      }
      
      // Dispatch ticketNoteCreated
      window.dispatch('ticketNoteCreated', update);
    },

    createTicketChat (update, open) {

      // Convert to array if it's not already
      if (!(_.isArray(update.data))) {
        update.data = [update.data];
      }
      
      // Store ticket chats
      update.data.forEach(comment => {
            
        // Add to Store
        this.$store.dispatch('storeTicketChatLiveUpdate', comment);

        // Add to List if necessary
        if (this.app.pages.tickets.selected === comment.ticket && this.app.pages.tickets.ticketChat.list.loaded) {
          this.app.pages.tickets.ticketChat.list.addItem(comment._id);
        }

        // Dispatch ticketUpdated
        window.dispatch('ticketChatCreated', comment);
      });
    },

    createNotification (update, open) {
      this.$store.commit('storeNotifications', [update.data]);
      this.app.activity.list.addItem(update.data._id, { unshift: true });
      if (!open) ActivityToast.show(update);
    }
    
  }
}


// WEBPACK FOOTER //
// ./src/mixins/liveUpdateMixin.js